export const reactions = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
